import { Fade } from "@progress/kendo-react-animation";
import { Notification, NotificationGroup } from "@progress/kendo-react-notification";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { removeNotification } from "./notificationSlice";

const Notifications: React.FC = () => {
    const dispatch = useAppDispatch();
    const notifications = useAppSelector(state => state.notifications.items);

    if (notifications.length === 0) {
        return null;
    }

    return (
        <NotificationGroup
            style={{
                right: 10,
                top: 70,
                zIndex: 1080
            }}
        >
            {notifications.map(notification => (
                <Fade key={notification.id}>
                    <Notification
                        type={{ style: notification.type, icon: notification.type != "error" }}
                        closable={true}
                        onClose={() => dispatch(removeNotification(notification.id))}
                    >
                        <span>{notification.message}</span>
                    </Notification>
                </Fade>
            ))}
        </NotificationGroup>
    );
};

export default Notifications;
